var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteOutlined = function SvgDeleteOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M11.319 9.775v7.836H9.776V9.775zM14.224 9.775H12.68v7.836h1.543z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M16.93 5.904H21v1.543h-1.996L17.898 21H6.103L4.997 7.447H3V5.904h4.07L7.94 3h8.119zM6.545 7.447l.98 12.01h8.95l.98-12.01zM8.68 5.904l.409-1.361h5.822l.408 1.361z",
    clipRule: "evenodd"
  })));
};
export default SvgDeleteOutlined;